/** Renders a percentage stat, with an em dash for "no data yet" rather than a
 * misleading 0%. */
export function formatPct(value: number | null): string {
  return value === null ? '—' : `${Math.round(value)}%`
}
